import { AUTH_COOKIE_KEY } from '../config'

const cookies = document.cookie.split('; ') || []
const cookie = (!!cookies.length && cookies.find((value) => value.split('=')[0] === AUTH_COOKIE_KEY)) || ''
const token = cookie.split('=').pop() || ''

export const headers = {
  authorization: `Bearer ${token}`,
}
